// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__12Kqn","title":"style_title__noIwX","prodWrap":"style_prodWrap__39HSV","oneCard":"style_oneCard__8Jno0","clicked":"style_clicked__2f55N"};